module.exports = __webpack_public_path__ + "img/sld_LT_1.b9b6e55a.svg";